import http from '@/api/http';
import { resGetListType } from '@/api/exportCenter/data';
const MODEL = '/export_center';
export default {
  // 导出中心 - 列表
  getList(data: resGetListType) {
    return http.post(`${MODEL}/list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 导出中心 - 删除
  onDel(data: { uuids: string[] }) {
    return http.post(`${MODEL}/batch_delete`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 导出中心 - 重试
  onRetry(data: { uuid: string }) {
    return http.post(`${MODEL}/retry`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
